module.exports = __webpack_public_path__ + "img/connectIPS.8f4ea4d2.png";